import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {
  AccountRecoveryResponse,
  AuthCreationForm,
  AuthCreationResponse,
  AuthLoginResponse,
  ChangePasswordRequest,
  PasswordResetRequest,
  PasswordResetTokenValidationResponse
} from "@models/auth.interface";
import {getDefaultHttpHeaders} from "../utils/http-headers.utils";

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private readonly BASE_URL: string = environment.apiUrl + "/auth";

  constructor(private http: HttpClient) {}

  login(email: string, password: string): Observable<AuthLoginResponse> {
    return this.http.post<AuthLoginResponse>(this.BASE_URL + "/login", {
      email,
      password
    }, {
      headers: getDefaultHttpHeaders().headers,
    });
  }

  forgotPassword(email: string): Observable<AccountRecoveryResponse> {
    return this.http.post<AccountRecoveryResponse>(this.BASE_URL + "/forgot-password", {email}, {
      headers: getDefaultHttpHeaders().headers,
    });
  }

  forgotIdentifier(email: string): Observable<AccountRecoveryResponse> {
    return this.http.post<AccountRecoveryResponse>(this.BASE_URL + "/forgot-identifier", {email}, {
      headers: getDefaultHttpHeaders().headers,
    });
  }

  inviteClient(email: string, clientName?: string, siren?: string): Observable<AccountRecoveryResponse> {
    return this.http.post<AccountRecoveryResponse>(this.BASE_URL + "/invite-client", {
      email,
      clientName: clientName?.trim() || null,
      siren: siren?.trim() || null
    }, {
      headers: getDefaultHttpHeaders().headers
    });
  }

  register(form: AuthCreationForm): Observable<AuthCreationResponse> {
     return this.http.post<AuthCreationResponse>(this.BASE_URL + "/register", form, {
      headers: getDefaultHttpHeaders().headers
     });
  }

  changeMyPassword(payload: ChangePasswordRequest): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/users/me/password`, payload, {
      headers: getDefaultHttpHeaders().headers
    });
  }

  validatePasswordResetToken(token: string): Observable<PasswordResetTokenValidationResponse> {
    return this.http.get<PasswordResetTokenValidationResponse>(
      `${this.BASE_URL}/reset-password/validate`,
      {
        headers: getDefaultHttpHeaders().headers,
        params: {token}
      }
    );
  }

  resetPassword(payload: PasswordResetRequest): Observable<AccountRecoveryResponse> {
    return this.http.post<AccountRecoveryResponse>(`${this.BASE_URL}/reset-password`, payload, {
      headers: getDefaultHttpHeaders().headers
    });
  }

  verifyEmail(token: string): Observable<AccountRecoveryResponse> {
    return this.http.get<AccountRecoveryResponse>(`${this.BASE_URL}/verify-email`, {
      headers: getDefaultHttpHeaders().headers,
      params: {token}
    });
  }

  resendVerification(email: string): Observable<AccountRecoveryResponse> {
    return this.http.post<AccountRecoveryResponse>(`${this.BASE_URL}/resend-verification`, {email}, {
      headers: getDefaultHttpHeaders().headers
    });
  }
}
